<template>
  <a
    class="float-contact"
    href="https://work.weixin.qq.com/kfid/kfcada7acc44b1348b6"
    target="_blank"
    rel="noopener noreferrer"
  >
    <img :src="kefuImg" alt="客服" />
  </a>
</template>

<script>
import kefuImg from '@/assets/images/kefu-logo-y.png'

export default {
  name: 'FloatContact',
  data() {
    return {
      kefuImg
    }
  }
}
</script>

<style lang="less" scoped>
.float-contact {
  position: fixed;
  right: 0;
  bottom: 150px;
  z-index: 9999;
  width: 55px;
  height: 55px;
  cursor: pointer;

  img {
    width: 100%;
    height: 100%;
    display: block;
    border-radius: 4px;
  }
}
</style>